var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4868_8502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8752 9.62777C18.4235 7.68941 14.4402 3.77344 9.99998 3.77344C5.87553 3.77344 1.91373 7.23918 0.124746 9.62777C-0.041582 9.84984 -0.041582 10.155 0.124746 10.3771C2.19893 13.1464 6.14057 16.2314 9.99998 16.2314C14.1244 16.2314 18.0862 12.7657 19.8752 10.3771C20.0416 10.155 20.0416 9.84984 19.8752 9.62777ZM9.99998 14.9814C6.75686 14.9814 3.52229 12.4934 1.42818 10.0026C2.45256 8.78566 5.94803 5.02344 9.99998 5.02344C13.2431 5.02344 16.4777 7.51141 18.5718 10.0023C17.5474 11.2192 14.0519 14.9814 9.99998 14.9814Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25C7.93227 6.25 6.25 7.93227 6.25 10C6.25 12.0677 7.93227 13.75 10 13.75C12.0677 13.75 13.75 12.0677 13.75 10C13.75 7.93227 12.0677 6.25 10 6.25ZM10 12.5C8.62148 12.5 7.5 11.3785 7.5 10C7.5 8.62148 8.62148 7.5 10 7.5C11.3785 7.5 12.5 8.62148 12.5 10C12.5 11.3785 11.3785 12.5 10 12.5Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99871 11.0443C10.574 11.0443 11.0404 10.5779 11.0404 10.0026C11.0404 9.42731 10.574 8.96094 9.99871 8.96094C9.42341 8.96094 8.95703 9.42731 8.95703 10.0026C8.95703 10.5779 9.42341 11.0443 9.99871 11.0443Z",
    fill: "#D2042D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4868_8502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.aec4a97cff12b84f37c30a93923330fb.svg";
export { ForwardRef as ReactComponent };